import { setApiAuth, setApiBaseUrl } from '@ziggiz/api';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app';
import { getAuthClient } from '@/auth/auth-runtime';
import '@/index.css';

setApiBaseUrl(import.meta.env.VITE_API_BASE_URL || '/api/v1');
setApiAuth(getAuthClient());

const container = document.getElementById('root');

if (!container) {
  throw new Error('Missing #root element in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
